import React, { useState, useEffect } from 'react';
import { Container, NavLink, NavItem, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import DesktopNavMenu from './DesktopNavMenu';
import { MotorhomeType } from '../Types';
import './NavMenu.css';
import Loader from 'Components/Loader';
import { VehicleAPI } from 'API/VehicleAPI';


function NavMenu() {
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const [motorhomes, setMotorhomes] = useState<MotorhomeType[]>([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getData = async() => {
            const motorhomes = await VehicleAPI.GetMotorhomes();
            setMotorhomes(motorhomes);
            setLoading(false)
        }
        getData();
    }, []);

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    }

    const toggle = () => {
        if (dropdownOpen) {
            setCollapsed(true);
        }
         setDropdownOpen(!dropdownOpen);
   }

    return (
        <Container>
            <DesktopNavMenu collapsed={collapsed} toggleNavbar={toggleNavbar}>
                <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle nav caret>
                        Motorhomes
                    </DropdownToggle>
                    <DropdownMenu>
                    {loading 
                    ? <Loader/>
                    : motorhomes &&  dropdownOpen && motorhomes.length > 0 &&
                        motorhomes.map((motorhome:MotorhomeType) => {
                            return (
                                <NavLink 
                                    className="nav-link-indent"
                                    key={motorhome.vehicle_id} 
                                    tag={Link} 
                                    to={{ pathname: '/Motorhome/'+ motorhome.vehicle_id+'/'+motorhome.name.replaceAll(' ','') }} 
                                    onClick={() => toggle()}
                                    >
                                    {motorhome.name}
                                </NavLink>
                            );
                        })
                    }
                    </DropdownMenu>
                </Dropdown>
                <NavItem>
                    <NavLink tag={Link} to="/Faqs" onClick={() => toggleNavbar()}>FAQs</NavLink>
                </NavItem>
            </DesktopNavMenu>
         </Container>
    );
}
export default NavMenu;
